import _ from 'lodash'

// Known prefixes to capitalize
const knownPrefixes = {
    gpt: 'GPT',
    gemini: 'Gemini',
    claude: 'Claude',
    mistral: 'Mistral',
    llama: 'Llama',
}

export function parseLLMModels (originalModels = []) {
    const models = originalModels.map((model) => {
        const modelValue = model.value.replace('meta-llama/', '') // temporary crop prefix for preview groq llama4 models.

        const withoutDate = modelValue.replace(/-\d{4}-\d{2}-\d{2}$/, '')
        const parts = withoutDate.split('-')

        const prefix = knownPrefixes[parts[0].toLowerCase()] || parts[0]
        const version = parts[1]
        const rest = parts.slice(2) // everything after prefix + version

        let label = version ? `${prefix}-${version}` : prefix
        if (rest.length) {
            label += ' ' + rest.join(' ')
        }
        return { ...model, label, }
    })

    return _.orderBy(models, ['value'], ['asc'])
}
